export default __webpack_public_path__ + "static/media/5_4.f346eeb1.jpg";